import * as React from 'react';
import AccountInformation from 'src/pages/Profile/AccountInformation'

export function ProfileAccountInformation() {

    return (
        <>
            <div className='container profile-page'>
                <h1 className='font-oswald font-light mobile-title'>Profile</h1>
                <AccountInformation />
            </div>
        </>
    );
}